class MatchHeight {
  /**
   * Create a new MatchHeight instance
   * @param selector CSS selector for the elements to match heights
   */
  constructor(selector) {
    this.elements = [];
    this.resizeTimeout = null;
    this.resizeHandler = null;
    this.selector = selector;
  }
  /**
   * Initialize the match height functionality
   */
  init() {
    this.elements = Array.from(
      document.querySelectorAll(this.selector)
    );
    if (this.elements.length === 0) {
      return;
    }
    this.matchHeights();
    this.resizeHandler = this.handleResize.bind(this);
    window.addEventListener("resize", this.resizeHandler);
  }
  /**
   * Match the heights of all elements
   */
  matchHeights() {
    this.elements.forEach((el) => {
      el.style.height = "auto";
    });
    const rows = {};
    this.elements.forEach((el) => {
      const top = el.getBoundingClientRect().top + window.scrollY;
      rows[top] = rows[top] || [];
      rows[top].push(el);
    });
    Object.keys(rows).forEach((rowKey) => {
      const rowElements = rows[Number(rowKey)];
      const heights = rowElements.map((el) => el.offsetHeight);
      const maxHeight = Math.max(...heights);
      rowElements.forEach((el) => {
        el.style.height = `${maxHeight}px`;
      });
    });
  }
  /**
   * Handle window resize events with debounce
   */
  handleResize() {
    if (this.resizeTimeout) {
      window.clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = window.setTimeout(() => {
      this.matchHeights();
    }, 150);
  }
  /**
   * Update heights manually (useful after content changes)
   */
  update() {
    this.matchHeights();
  }
  /**
   * Clean up event listeners
   */
  destroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.resizeTimeout) {
      window.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = null;
    }
    this.elements.forEach((el) => {
      el.style.height = "auto";
    });
    this.elements = [];
  }
}
function createMatchHeight(selector) {
  const matchHeight = new MatchHeight(selector);
  matchHeight.init();
  return matchHeight;
}
export {
  createMatchHeight as c
};
